// extracted by mini-css-extract-plugin
export default {"container":"Home_container__p7nbF","input-box":"Home_input-box__u5Ir5","title":"Home_title__ZlDSH","Enterdata":"Home_Enterdata__kly3u","output-box":"Home_output-box__UwiDU"};